import logo from "./redIcon.png";
import './App.css';
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";

import Footer from "./Footer";

import { useState, useEffect, useRef } from 'react';

import { firestore, auth, storage } from "./firebase";
import { collection, doc, getDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

signInWithEmailAndPassword(auth, "scottymart07@gmail.com", process.env.PASSWORD);

let cache = [];

function TagButton(props) {
  if (props.tag === "") return <div></div>;
  else {
    return (
      <button className="bg-ddg mt-5 mx-10 lg:mr-5 lg:ml-0 px-16 py-1 rounded-lg text-base">{props.tag}</button>
    )
  }
}

function StatusButton(props) {
  let button;
  if (props.status === "Complete") button = <button className="bg-ddc mx-10 lg:ml-20 mt-5 px-20 py-1 rounded-lg text-base">{props.status}</button>;
  else if (props.status === "Demo") button = <button className="bg-ddy mx-10 lg:ml-20 mt-5 px-10 py-1 rounded-lg text-base">{props.status}</button>;
  else button = <button className="bg-ddo mx-10 lg:ml-20 lg:ml-20 mt-5 px-5 lg:px-10 py-1 rounded-lg text-base">{props.status}</button>;
  return button;
}

function ContestButton(props) {
  let button;
  if (props.contest === 1) button = <button className="bg-[#d6ac13] mx-10 lg:ml-20 mt-5 px-20 py-1 rounded-lg text-base animate-pulse">Contest Winner</button>;
  else if (props.contest === 2) button = <button className="bg-[#856d15] mx-10 lg:ml-20 lg:ml-20 mt-5 px-5 lg:px-10 py-1 rounded-lg text-base">Contest Runner-Up</button>;
  else button = <div></div>;
  return button;
}

function Version(props) {
  const [url, setUrl] = useState(null);
  const worldpackRef = ref(storage, `Packs/${props.name}.worldpack`);
  getDownloadURL(worldpackRef).then(url => {
    setUrl(url);
  });
  return (
    <div className="bg-ddg mx-5 lg:mx-0 py-5 mt-5 rounded-lg">
      <p className="text-xl ml-5 fontTitle">{props.name}</p>
      <p className="text-sm ml-5 lg:text-base xl:mr-80">{props.desc}</p>
      <button onClick={() => window.open(url)}className="bg-darkc ml-5 hover:bg-ddc transition duration-50 px-5 py-3 mt-2 rounded-lg text-base">Download</button>
    </div>
  );
}

function checkTags(all) {
  let selected = [];
  all.forEach(tag => {
    if (tag.current.className[4] === "d") selected.push(tag.current.id);
  });
  return selected;
}

function checkStatus(all) {
  let selected = [];
  all.forEach(tag => {
    if (tag.current.className[5] !== "d") selected.push(tag.current.id);
  });
  return selected;
}

const TagSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("w");
  function toggle() {
    if (checkTags(props.all).length < 2 || color === "g") {
      if (color === "w") setColor("g");
      else setColor("w");
    }
  }
  if (color === "g") return <button onClick={toggle} id={props.tag} ref={ref} className="bg-ddg mt-4 px-6 py-1 text-sm rounded-lg">{props.tag}</button>;
  else return <button onClick={toggle} id={props.tag} ref={ref} className="bg-darkgr mt-4 px-6 py-1 text-sm rounded-lg">{props.tag}</button>;
});

const StatusSelectButton = React.forwardRef((props, ref) => {
  const [color, setColor] = useState("d"); // D = dark, B = bright
  function toggle() {
    if (checkStatus(props.all).length < 1 || color === "b") {
      if (color === "d") setColor("b");
      else setColor("d");
    }
  }
  if (props.status === "Complete") {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddc mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddc mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  } else if (props.status === "Demo") {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddy mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddy mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  } else {
    if (color === "d") return <button onClick={toggle} id={props.status} ref={ref} className="bg-dddo mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
    else return <button onClick={toggle} id={props.status} ref={ref} className="bg-ddo mt-4 px-6 py-1 text-sm rounded-lg">{props.status}</button>;
  }
});

function Edit() {

  const [docSnap, setDocSnap] = useState(null);
  const [img, setImg] = useState(<br/>);
  const [imgFound, setImgFound] = useState(false);
  const { packId } = useParams();

  const packName = useRef(null);
  const packDesc = useRef(null);
  const packLong = useRef(null);
  const packAuthor = useRef(null);

  const tagTraditional = useRef(null);
  const tagStory = useRef(null);
  const tagDifficult = useRef(null);
  const tagKaizo = useRef(null);
  const tagSequel = useRef(null);
  const tagDecoration = useRef(null);
  const tagGimmick = useRef(null);
  const tagFriends = useRef(null);
  const tagAbility = useRef(null);
  const tagPurple = useRef(null);

  let allTags = [tagTraditional, tagStory, tagDifficult, tagKaizo, tagSequel, tagDecoration, tagGimmick, tagFriends, tagAbility, tagPurple];

  const statusComplete = useRef(null);
  const statusDemo = useRef(null);
  const statusBeta = useRef(null);

  let allStatus = [statusComplete, statusDemo, statusBeta];
  
  async function FindData() {
    let docFound;
    let cacheFound = cache.find(pack => pack.id === packId);
    if (!cacheFound) {
      const docRef = doc(firestore, "Packs", packId);
      docFound = await getDoc(docRef);
      cache.push({
        id: docFound.id,
        data: docFound.data()
      });
      docFound = {
        id: docFound.id,
        data: docFound.data()
      };
    }
    else docFound = cacheFound;
    setDocSnap(docFound);
  }

  if (!docSnap) FindData();

  if (docSnap && docSnap.data.banner && !imgFound) {
    let foundRef = ref(storage, `Images/${docSnap.data.banner}`);
    getDownloadURL(foundRef).then(url => {
      setImg(<img src={url} className="" alt="banner"/>);
      setImgFound(true);
    });
  }

  if (docSnap && !docSnap.data.banner && !imgFound) {
    setImgFound(true);
    setImg(<div><br/></div>);
  }

  if (!docSnap) return (
    <div className="App bg-gradient-to-br from-ddp to-darkp min-h-screen">
      <br/>
      <p className="text-3xl ml-20 mt-20 font-bold">Loading pack...</p>
    </div>
  );

  function FigureOutTags(props) { //inline-grid grid-cols-1 grid-rows-2 md:grid-cols-4 md:grid-rows-1
    const data = props.data;
    if (data.tags.length === 2) return (
      <div className="lg:ml-20 lg:flex">
        <TagButton tag={data.tags[0]}/>
        <TagButton tag={data.tags[1]}/>
      </div>
    );
    else if (data.tags.length === 1) return (
      <div className="lg:ml-20 lg:flex">
        <TagButton tag={data.tags[0]}/>
      </div>
    );
    else return <div></div>;
  }

  let versions = <div></div>;
  docSnap.data["Versions"].forEach(version => {
    versions = <div>
      {versions}
      <Version name={version["Name"]} desc={version["Desc"]} data={docSnap.data}/>
    </div>;
  });

  return (
    <div className="App bg-gradient-to-b from-ddp to-darkp pt-20">
      <header className="">
        {img}
        <p className="ml-20 mt-12 text-2xl md:text-4xl lg:text-6xl font-bold fontTitle">
          Editing {docSnap.data.name}...
        </p>
      </header>
      <div className="mt-3 lg:mt-5 text-sm md:text-base lg:text-lg xl:text-xl mx-5 lg:ml-20 lg:mr-16 xl:mr-48">
        <div className="mt-5">
          <p className="text-lg">Pack Description: (200 character limit)</p>
          <textarea type="text" ref={packDesc} placeholder="" maxLength="200" className="w-5/6 md:w-3/4 lg:w-2/3 h-16 text-black text-base">{docSnap.data.desc}</textarea>
        </div>
        <div className="mt-5">
          <p className="text-lg">Long Pack Description:</p>
          <textarea type="text" ref={packLong} placeholder="" className="w-5/6 md:w-3/4 lg:w-2/3 h-24 text-black text-base">{docSnap.data.long}</textarea>
        </div>
        <div className="mt-5 mr-52">
          <p className="text-lg">Current Tags:</p> 
          <FigureOutTags data={docSnap.data} className=""/>
          <p className="text-lg mt-5">Updated Tags: (up to 2)</p>
          <div className="grid grid-rows-5 grid-cols-2 md:grid-rows-2 md:grid-cols-5 gap-1 mx-2 md:mx-0 -ml-2">
              <TagSelectButton tag="Traditional" ref={tagTraditional} all={allTags}/>
              <TagSelectButton tag="Story" ref={tagStory} all={allTags}/>
              <TagSelectButton tag="Difficult" ref={tagDifficult} all={allTags}/>
              <TagSelectButton tag="Sequel" ref={tagSequel} all={allTags}/>
              <TagSelectButton tag="Kaizo" ref={tagKaizo} all={allTags}/>
              <TagSelectButton tag="Gimmick" ref={tagGimmick} all={allTags}/>
              <TagSelectButton tag="Decoration" ref={tagDecoration} all={allTags}/>
              <TagSelectButton tag="Friends" ref={tagFriends} all={allTags}/>
              <TagSelectButton tag="Ability" ref={tagAbility} all={allTags}/>
              <TagSelectButton tag="Purple" ref={tagPurple} all={allTags}/>
          </div>
          <p className="text-base mt-3">Selecting 2 tags for your pack is highly recommended.</p>
          <p className="text-base">These tags will replace your current tags.</p>
        </div>
        <div className="mt-8 mr-52">
          <p className="text-lg">Current Status:</p>
          <StatusButton status={docSnap.data.status}/>
          <p className="text-lg mt-4">Updated Status:</p>
          <div className="grid grid-rows-1 grid-cols-3 gap-1">
            <StatusSelectButton status="Complete" ref={statusComplete} all={allStatus}/>
            <StatusSelectButton status="Demo" ref={statusDemo} all={allStatus}/>
            <StatusSelectButton status="Beta" ref={statusBeta} all={allStatus}/>
          </div>
          <p className="text-base mt-3 mr-16"><b>Complete</b> packs are finished, though they may receive small updates from time to time.</p>
          <p className="text-base mr-5"><b>Demos</b> have a good amount of content already, but are not finished yet.</p>
          <p className="text-base mr-5"><b>Betas</b> are only the first world or few rooms of a pack.</p>
        </div>
      </div>
      <br/>
      <ContestButton contest={docSnap.data.contest}/>
      <br/>
      <div className="mt-10 mb-10 lg:ml-20 lg:mr-32 xl:mr-72">
        {versions}
      </div>
      <button onClick={() => window.location.replace("/")} className="bg-darkc ml-20 mb-20 hover:bg-ddc transition duration-50 px-5 py-3 mt-2 rounded-lg text-base">⇦ Back to search</button>
      <br/>
      <Footer/>
    </div>
  );
}

export default Edit;